import _uniq from "lodash/uniq";
import {
  GET_RECRUITS_PAGE_REQUEST,
  GET_RECRUITS_PAGE_SUCCESS,
  GET_RECRUITS_PAGE_FAILURE,
  DELETE_RECRUITS_PAGE_REQUEST,
  DELETE_RECRUITS_PAGE_SUCCESS,
  DELETE_RECRUITS_PAGE_FAILURE,
  SET_SELECTED_RECRUIT,
  SET_ALL_RECRUITS_SELECTED,
  SET_RECRUITS_BULK,
  RESET_GENERATED_CSV,
  GENERATE_CSV_RECRUITS_SUCCESS,
  IMPORT_CSV_RECRUITS_SUCCESS,
  GET_LANDINGS_FOR_SELECTOR_SUCCESS,
  POST_SMS_CAMPAIGN_FAILURE,
  POST_SMS_CAMPAIGN_SUCCESS,
  POST_SMS_CAMPAIGN_REQUEST,
  POST_SEND_SMS_REQUEST,
  POST_SEND_SMS_SUCCESS,
  POST_SEND_SMS_FAILURE,
  POST_ASSOCIATE_WITH_SMS_CAMPAIGN_SUCCESS,
  SET_SMS_CAMPAIGNS_FOR_SELECTOR,
} from './actionTypes';
import {
  PUT_SMS_CAMPAIGN_SUCCESS,
  DELETE_SMS_CAMPAIGN_SUCCESS,
  PUT_SMS_CAMPAIGN_REQUEST,
  PUT_SMS_CAMPAIGN_FAILURE,
} from './SmsCampaigns/actionTypes';
import { GET_CHAT_MESSAGES_SUCCESS } from './ChatComponent/actionTypes';

import { toggleSelected } from '../../../core/helpers/default';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
  from: 1,
  to: 1,
  total: 1,
  recruitsIds: [],
  generatedCSV: null,
  refetchRecruits: false,
  landingsForSelector: [],
  sendingSms: false,
  smsCampaignsForSelector: [],
};

const recruitsReducer = (state = initialState, {
  type,
  error,
  data,
  meta,
  recruitId,
  selectAllRecruits,
  generatedCSV,
  landingsForSelector,
  smsCampaignsForSelector,
  bulkMeta,
}) => {
  switch (type) {
    case GET_RECRUITS_PAGE_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_RECRUITS_PAGE_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        from: meta.from,
        to: meta.to,
        total: meta.total,
        loading: false,
      };
    case GET_RECRUITS_PAGE_FAILURE:
      return { ...state, loading: false, error };
    case DELETE_RECRUITS_PAGE_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_RECRUITS_PAGE_SUCCESS:
      return {
        ...state,
        refetchRecruits: !state.refetchRecruits,
        loading: false,
      };
    case DELETE_RECRUITS_PAGE_FAILURE:
      return { ...state, loading: false, error };
    case SET_SELECTED_RECRUIT:
      return {
        ...state,
        recruitsIds: toggleSelected(state.recruitsIds, recruitId),
        data: state.data.map((i) => (recruitId === i.id ? { ...i, _selected: !i._selected } : i)),
      };
    case SET_RECRUITS_BULK:
      // eslint-disable-next-line no-case-declarations
      const { prev, next } = bulkMeta;
      if (prev) {
        const recruitsIdsToCheck = [];
        let tempDataForBulkOperation = [];
        const prevIndex = state.data.findIndex((el) => el.id === prev);
        const nextIndex = state.data.findIndex((el) => el.id === next);
        state.data.forEach((el, key) => {
          if (key >= prevIndex && key <= nextIndex) {
            recruitsIdsToCheck.push(el.id);
            tempDataForBulkOperation = [...tempDataForBulkOperation, { ...el, _selected: true }];
          } else {
            tempDataForBulkOperation = [...tempDataForBulkOperation, el];
          }
        });
        return {
          ...state,
          recruitsIds: _uniq([...state.recruitsIds, ...recruitsIdsToCheck]),
          data: tempDataForBulkOperation,
        };
      }
      return state;
    case SET_ALL_RECRUITS_SELECTED:
      return {
        ...state,
        recruitsIds: selectAllRecruits ? state.data.map(({ id }) => id) : [],
        data: state.data.map((i) => ({ ...i, _selected: selectAllRecruits })),
      };
    case IMPORT_CSV_RECRUITS_SUCCESS:
    case PUT_SMS_CAMPAIGN_SUCCESS:
    case DELETE_SMS_CAMPAIGN_SUCCESS:
    case GET_CHAT_MESSAGES_SUCCESS:
      return {
        ...state,
        refetchRecruits: !state.refetchRecruits,
      };
    case GENERATE_CSV_RECRUITS_SUCCESS:
      return {
        ...state,
        generatedCSV,
      };
    case GET_LANDINGS_FOR_SELECTOR_SUCCESS:
      return {
        ...state,
        landingsForSelector,
      };
    case POST_SMS_CAMPAIGN_REQUEST:
    case PUT_SMS_CAMPAIGN_REQUEST:
      return { ...state, error: null };
    case POST_SMS_CAMPAIGN_SUCCESS:
    case POST_ASSOCIATE_WITH_SMS_CAMPAIGN_SUCCESS:
      return { ...state, recruitsIds: [], refetchRecruits: !state.refetchRecruits };
    case POST_SMS_CAMPAIGN_FAILURE:
    case PUT_SMS_CAMPAIGN_FAILURE:
      return { ...state, error };
    case POST_SEND_SMS_REQUEST:
      return { ...state, sendingSms: true };
    case POST_SEND_SMS_SUCCESS:
      return { ...state, sendingSms: false, refetchRecruits: !state.refetchRecruits };
    case POST_SEND_SMS_FAILURE:
      return { ...state, error, sendingSms: false };
    case RESET_GENERATED_CSV:
      return {
        ...state,
        generatedCSV: null,
      };
    case SET_SMS_CAMPAIGNS_FOR_SELECTOR:
      return {
        ...state,
        smsCampaignsForSelector,
      };
    default:
      return state;
  }
};

export default recruitsReducer;
